'use client';

// Core
import { FC } from 'react';

interface THeader {
  label?: string;
  title?: string;
}

export const Header: FC<THeader> = ({ label, title }) => {
  return (
    <div className="w-full flex flex-col gap-y-2 justify-center">
      <h1 className="text-3xl font-semibold">{title}</h1>
      <p className="text-muted-foreground text-sm">{label}</p>
    </div>
  );
};
